/**
 * Formats a navigation badge count for display, capping large values at
 * "99+" so the badge pill keeps a fixed, compact footprint.
 *
 * @param {number} count - the raw unread / match count
 * @returns {string} the display string rendered inside the badge
 */
const formatBadgeCount = (count: number): string => {
  if (count > 99) {
    return '99+'
  }

  return count.toString()
}

export { formatBadgeCount }
